import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { leadQueryKeys } from "./leadQueryKeys";

export function useQueryLeadListCount(
  {
    api,
    filters,
    tz,
  }: {
    api: ApiType;
    filters?: Parameters<ApiType["leadApi"]["listCount"]>[0];
    tz: string;
  },
  queryOpts?: Omit<
    UseQueryOptions<unknown, unknown, { count: number }>,
    "queryKey"
  >,
) {
  return useQuery({
    queryKey: leadQueryKeys.listCount(filters),
    queryFn: async () => {
      const parsedOpts = { ...filters };
      if (filters?.createdFrom) {
        parsedOpts.createdFrom = zonedTimeToUtc(filters.createdFrom, tz);
      }
      if (filters?.createdTo) {
        parsedOpts.createdTo = zonedTimeToUtc(filters.createdTo, tz);
      }
      return (await api.leadApi.listCount(parsedOpts)).data;
    },
    ...queryOpts,
  });
}
